const { VUE_APP_API } = process.env;

export const API_URL = VUE_APP_API;

export default {
  API_URL,
};
